<svg
  width="24"
  height="20"
  viewBox="0 0 24 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect x="0" y="11" width="4" height="9" fill="currentColor" />
  <rect x="6" y="4" width="4" height="16" fill="currentColor" />
  <rect x="12" y="8" width="4" height="12" fill="currentColor" />
  <rect x="18" y="2" width="4" height="18" fill="currentColor" />
</svg>
